import { TConfig } from './Config.domain';
import instanse from '@/common/service/api/Axios';
import { ApiUrls } from '@/common/domain/Endpoints.domain';

export const fetchConfig = (id?: string): Promise<TConfig> => {
    return instanse.get<TConfig>(ApiUrls.config.root, { params: { id } }).then(({ data }) => data);
};
